import React from 'react';
import Counter from './Counter';

function Counter_Area() {
  return (
    <div className="counter-area-2" style={{ backgroundImage: "url('assets/img/bg/counter-bg_1.png')" }}>
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-sm-6 col-xl-3 counter-card-wrap">
            <div className="counter-card">
              <h2 className="counter-card_number">
                <Counter target="3.9" duration={1000} />k
              </h2>
              <p className="counter-card_text"><strong>Successfully</strong> Trained</p>
            </div>
          </div>
          <div className="col-sm-6 col-xl-3 counter-card-wrap">
            <div className="counter-card">
              <h2 className="counter-card_number">
                <Counter target="15.8" duration={1000} />k
              </h2>
              <p className="counter-card_text"><strong>Classes</strong> Completed</p>
            </div>
          </div>
          <div className="col-sm-6 col-xl-3 counter-card-wrap">
            <div className="counter-card">
              <h2 className="counter-card_number">
                <Counter target="97.5" duration={1000} />k
              </h2>
              <p className="counter-card_text"><strong>Satisfaction</strong> Rate</p>
            </div>
          </div>
          <div className="col-sm-6 col-xl-3 counter-card-wrap">
            <div className="counter-card">
              <h2 className="counter-card_number">
                <Counter target="100.2" duration={1000} />k
              </h2>
              <p className="counter-card_text"><strong>Students</strong> Community</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Counter_Area;
